import React from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './Footer.css';

// Import Logo (Replace with your actual logo path)
import logo from '../../assets/Logo.webp';

const Footer = () => {
  return (
    <footer className="footer-section">
      <div className="container">

        {/* --- TOP ROW: Logo & Newsletter --- */}
        <div className="footer-top">
          {/* Left: Logo */}
          <div className="footer-brand">
            <img 
              src={logo} 
              alt="Dazbog Logo" 
              className="footer-logo" 
              loading="lazy"
              decoding="async"
            />
          </div>

        </div>

        {/* --- MIDDLE ROW: 4 Columns --- */}
        <div className="row footer-links-row">

          {/* Col 1: Company Links */}
          <div className="col-lg-3 col-md-6 mb-4 mb-lg-0">
            <h5 className="footer-col-title">Company</h5>
            <ul className="footer-links-list">
              <li><Link to="/about" className="footer-link">About Us</Link></li>
              <li><Link to="/projects" className="footer-link">Projects</Link></li>
              <li><Link to="/fullteam" className="footer-link">Teams</Link></li>
              <li><Link to="/contact" className="footer-link">Contact</Link></li>
            </ul>
          </div>

          {/* Col 2: Corporate Office */}
          <div className="col-lg-3 col-md-6 mb-4 mb-lg-0 address-block">
            <h5 className="footer-col-title">Corporate Office</h5>
            <p><strong>Pune, Maharashtra</strong></p>
            <p>
              Unit 702, 7th Floor, The Golden Bell,<br />
              Pingale Wasti, Koregaon Park Annexe,<br />
              Mundhwa, Pune - 411036
            </p>
          </div>

          {/* Col 3: Regional Branches */}
          <div className="col-lg-3 col-md-6 mb-4 mb-lg-0 address-block">
            <h5 className="footer-col-title">Regional Branches</h5>
            <p><strong>Gurugram, Haryana</strong></p>
            <p>DLF Corporate Greens, Sector 74A</p>
            <p className="mt-2"><strong>Patna, Bihar</strong></p>
            <p>Tha modern cowork, Sri Krishna Puri</p>
          </div>

          {/* Col 4: International (US Address) */}
          <div className="col-lg-3 col-md-6 address-block">
            <h5 className="footer-col-title">International</h5>
            <p><strong>Virginia, USA</strong></p>
            <p>
              43260 Mitcham Square,<br />
              Ashburn, Virginia, United States<br />
              of America – 20148
            </p>
          </div>

        </div>

        {/* --- ICONS ROW --- */}
        <div className="footer-icon-row">

          {/* Icon 1: Email */}
          <div className="icon-item">
            <i className="bi bi-envelope footer-icon"></i>
            <span>info@dazbog.in</span>
          </div>

          {/* Icon 2: Phone */}
          <div className="icon-item">
            <i className="bi bi-telephone footer-icon"></i>
            <span>+91 88009 54675</span>
          </div>

          {/* Icon 3: Location */}
          <div className="icon-item">
            <i className="bi bi-geo-alt footer-icon"></i>
            <span>DLF Corporate Greens, Gurugram, Haryana, India</span>
          </div>

        </div>

        {/* --- BOTTOM ROW: Copyright & Legal --- */}
        <div className="footer-divider"></div>

        <div className="footer-bottom">
          <div className="copyright">
            Copyright © 2026 - All Rights Reserved
          </div>

          <div className="bottom-links">
            <a href="#terms">Terms and Conditions</a> |
            <a href="#privacy">Privacy Policy</a>
          </div>

          <div className="designer" style={{ color: "#c7c7c7" }}>
            Designed by Ascent Brandworks
          </div>


        </div>

      </div>
    </footer>
  );
};

export default Footer;